import React, { useState, useEffect } from "react";
import { BtnPrimary } from "../../../Components/share/buttons/Btn";
import DashCard from "../../../Components/share/cards/DashCard";
import { AiOutlineAppstore } from "react-icons/ai";
import { Modal } from "../../../Components/share/modal/Modal";
import BootCampMember from "../../../Components/layouts/StudentCourse/BootCampMember";
import useFetch from "../../../Hooks/useFetch";
import moment from "jalali-moment";

function BootCamp() {
    const [participants, setParticipants] = useState("");
    const [organizer, setOrganizer] = useState("");
    const [bootcampData, setBootcampData] = useState("");
    const [showMember, setShowMember] = useState(false);

    const getparticipants = useFetch({
        method: "GET",
        url: `BootCampService/11/bootcamp_participants`,
        noHeader: false,
        trigger: true,
        setter: setParticipants,
    });
    //Todo : id bootcamp dynamic she

    const getBootcampData = useFetch({
        method: "GET",
        url: `UserBootCampService/11`,
        noHeader: false,
        trigger: true,
        setter: setBootcampData,
    });
    //Todo : id bootcamp dynamic she

    const getOrganizer = useFetch({
        method: "GET",
        url: `OrganizerService/${bootcampData.organizer}`,
        noHeader: false,
        trigger: false,
        setter: setOrganizer,
    });
    //Todo : id bootcamp dynamic she

    useEffect(() => {
        bootcampData && getOrganizer.reFetch();
    }, [bootcampData]);

    return (
        <div>
            <div className=" flex SupportTicket__header justify-between items-center pt-24">
                <h3 className=" text-[#77498F] text-[1.6rem] font-bold">
                    اطلاعات کلی بوت کمپ
                </h3>
                <BtnPrimary
                    text="نمایش لیست شرکت کنندگان"
                    className=" px-12 py-8 mt-6 mb-8"
                    onClick={() => setShowMember(!showMember)}
                />
            </div>
            <DashCard className="flex pt-[1.6rem] pb-[8.1rem] px-[1.6rem] flex-col mt-[4.5rem] w-11/12 mr-[0.4rem] mb-[5.6rem] shadow-btn bg-[#FBF7FF]">
                <div className="grid grid-cols-3 gap-x-[2.5rem]">
                    <div className=" bg-white rounded-[1.5rem] pt-[0.9rem] px-[1.2rem] pb-[2.1rem] col-span-2">
                        <img
                            src={bootcampData.bootcamp_cover}
                            alt={"cover"}
                            className=" max-w-[37.2rem] max-h-[24.9rem] rounded-[1.5rem] mb-[2.1rem] text-center mx-auto"
                        />
                        <div className=" flex flex-row justify-between items-center">
                            <div className=" flex flex-col">
                                {/* <p className=" text-[#21212199] text-[1.2rem] leading-[2.4rem] font-normal">
                                    <span>5 </span> جلسه
                                </p> */}
                                <p className=" text-[#21212199] text-[1.2rem] leading-[2.4rem] font-normal">
                                    قیمت:
                                    <span className=" mr-[0.2rem]">
                                        {bootcampData.bootcamp_price}{" "}
                                    </span>
                                    تومان
                                </p>
                                <p className=" text-[#21212199] text-[1.2rem] leading-[2.4rem] font-normal">
                                    <AiOutlineAppstore className=" inline-block text-[#21212199] text-[2.4rem]" />
                                    <span className=" mr-[0.6rem]">
                                        {bootcampData.bootcamp_category}
                                    </span>{" "}
                                </p>
                            </div>
                            <div className=" flex flex-col">
                                <p className=" text-[#21212199] text-[1.2rem] leading-[2.4rem] font-normal">
                                    شروع بوت کمپ:{" "}
                                    <span>
                                        {moment(
                                            bootcampData.bootcamp_start_time
                                        )
                                            .locale("fa", {
                                                useGregorianParser: true,
                                            })
                                            .format("YYYY/MM/DD")}
                                    </span>
                                </p>
                                <p className=" text-[#21212199] text-[1.2rem] leading-[2.4rem] font-normal">
                                    پایان بوت کمپ:{" "}
                                    <span>
                                        {moment(bootcampData.bootcamp_end_time)
                                            .locale("fa", {
                                                useGregorianParser: true,
                                            })
                                            .format("YYYY/MM/DD")}
                                    </span>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className=" bg-white rounded-[1.5rem] pt-[0.9rem] px-[1.2rem] pb-[2.1rem]">
                        <img
                            src={organizer?.organizer_avatar}
                            alt={"avatar"}
                            className=" max-w-[8.418rem] max-h-[8.4rem] rounded-[1.5rem] text-center mx-auto"
                        />
                        <p className=" mt-[1.7rem] text-black text-[1.6rem] font-bold leading-[3.2rem] text-center">
                            {organizer.organizer_name}
                        </p>
                        <p className=" text-[#21212199] text-[1rem] font-normal leading-[1.5rem] max-w-[18.5rem] mx-auto mt-[2.3rem]">
                            {organizer.organizer_description}
                        </p>
                    </div>
                </div>
                <div className=" mt-[5.3rem]">
                    <p className=" text-[#212121E5] text-[2rem] leading-[3.2rem] font-bold mb-[0.9rem]">
                        توضیحات بوت کمپ
                    </p>

                    <p className=" text-[#212121E5] text-[1.4rem] leading-[2.45rem] pt-5">
                        {bootcampData.bootcamp_description}
                    </p>
                </div>
                {/* <p className=" text-[#77498F] text-[1.6rem] leading-[2.4rem] font-normal mt-[2rem] text-left cursor-pointer">
                    مشاهده توضیحات کامل
                </p> */}
            </DashCard>
            {showMember && (
                <Modal show={showMember}>
                    <BootCampMember
                        close={setShowMember}
                        participants={participants?.results}
                    />
                </Modal>
            )}
        </div>
    );
}

export default BootCamp;
const points = [
    {
        text: "سادگی و زیبایی: طراحی نرم افزار حسابداری محک، در عین زیبایی، ساده بوده و به راحتی قابل استفاده می‌باشد.",
    },
    {
        text: "به‌روز بودن: محک با استفاده از جدیدترین تکنولوژی‌ها و فناوری‌ روز دنیا در خدمت شما است.",
    },
    {
        text: "حمایت از مشتری: با پشتیبانی نرم افزار حسابداری محک، دیگر نگران سؤالات و مشکلات خود نخواهید بود.",
    },
    {
        text: "صرفه اقتصادی: استفاده از نرم افزار حسابداری محک در مقایسه با دیگر راهکارها بسیار به‌صرفه است.",
    },
    {
        text: "دقت و امنیت: نرم افزار حسابداری محک از بروز خطای انسانی جلوگیری کرده و دقت محاسبات را افزایش می‌دهد.",
    },
    {
        text: "راه‌کارهای تخصصی: افزونه‌های محک کمک می‌کنند تا در عین سادگی محیطی تخصصی برای صنف خود داشته باشید.",
    },
];
